import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import moment from 'lib/moment-timezone-custom'

export default class TimeSelect extends Component {
  static propTypes = {
    selected: PropTypes.object,
    onChange: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      timeAsOptions: [{ label: 'During all day', value: null }],
    }

    this.state.timeAsOptions.push({
      label: 'Morning',
      value: {
        from: moment().hour(3).minute(0).second(0),
        to: moment().hour(11).minute(59).second(59),
      },
    })

    this.state.timeAsOptions.push({
      label: 'Afternoon',
      value: {
        from: moment().hour(12).minute(0).second(0),
        to: moment().hour(16).minute(59).second(59),
      },
    })

    this.state.timeAsOptions.push({
      label: 'Evening',
      value: {
        from: moment().hour(17).minute(0).second(0),
        to: moment().hour(20).minute(59).second(59),
      },
    })

    this.state.timeAsOptions.push({
      label: 'Night',
      value: {
        from: moment().hour(21).minute(0).second(0),
        to: moment().hour(23).minute(59).second(59),
      },
    })
  }

  componentDidMount () {
    this.updatePlaceholder(this.props)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.updatePlaceholder(nextProps)
    }
  }

  updatePlaceholder (props) {
    var index = -1
    if (props.selected) {
      index = this.state.timeAsOptions.findIndex(function (option) {
        if (option.value) {
          return props.selected.from === option.value.from
        } else {
          return false
        }
      })
    }

    if (index >= 0) {
      this.setState({ placeholder: this.state.timeAsOptions[index].label })
    } else {
      this.setState({ placeholder: 'Full Day' })
    }
  }

  onChange (option) {
    this.setState({ placeholder: option.label })
    this.props.onChange(option.value)
  }

  render () {
    return (
      <Select
        className="schedule_time_select"
        searchable={false}
        clearable={false}
        name="date-select"
        placeholder={this.state.placeholder}
        options={this.state.timeAsOptions}
        onChange={this.onChange.bind(this)}
        aria-label="Time Select"
      />
    )
  }
}
